const Loader = () => {
  return (
    <div className="flex">
      <div className="m-auto">
        <img
          src="/assets/light-loader.gif"
          alt="loader"
          className="h-10 w-10"
        />
      </div>
    </div>
  );
};

export const FullLoader = () => {
  return (
    <div className="flex h-screen">
      <div className="m-auto">
        <img
          src="/assets/light-loader.gif"
          alt="loader"
          className="h-10 w-10"
        />
      </div>
    </div>
  );
};

export default Loader;
